import { Create, Datagrid, EditButton, List, TextField } from 'react-admin';
import { Edit, SimpleForm, TextInput } from 'react-admin';

export const Petugas_pstList = () => (
    <List>
        <Datagrid>
            <TextField source="id" label="Niplama" />
            <TextField source="nama" />
            <TextField source="image_path" />
            <EditButton/>
        </Datagrid>
    </List>
);

export const Petugas_pstEdit = () => (
    <Edit>
        <SimpleForm>
            <TextInput source="id" label="Niplama" />
            <TextInput source="nama" />
            <TextInput source="image_path" />
        </SimpleForm>
    </Edit>
);

export const Petugas_pstCreate = () => (
    <Create>
        <SimpleForm>
            <TextInput source="id" label="Niplama" />
            <TextInput source="nama" />
            <TextInput source="image_path" />
        </SimpleForm>
    </Create>
);